/* eslint-disable no-underscore-dangle */

export function sortByDate(a, b) {
  return a.dateFrom - b.dateFrom;
}
